import { isLocalEnvironment } from '@/environment'
import { LANDING_DIRECT_CONVERSION_EXPERIMENT, LANDING_DIRECT_CONVERSION_TREATMENT } from '@tipi/shared'

import { FOOD_COST_LANDING_PAGE } from './constants'

export const PROD_APP_ORIGIN = 'https://app.oidotipi.com'
export const LOCAL_APP_ORIGIN = 'http://localhost:5174'

/** Production app origin. Prefer `resolveAppOrigin()` for runtime links. */
export const APP_ORIGIN = PROD_APP_ORIGIN

export function resolveAppOrigin(): string {
    const override = import.meta.env.VITE_APP_ORIGIN?.trim()
    if (override) {
        return override.replace(/\/$/, '')
    }
    if (isLocalEnvironment) {
        return LOCAL_APP_ORIGIN
    }
    return PROD_APP_ORIGIN
}

export type AppOutboundCta = 'pricing_cta' | 'hero_cta' | 'header_cta' | 'client_access' | 'post_lead_offer'

export type AppOutboundOptions = {
    leadId?: string
    /** ISO timestamp for the 24h intro deadline (landing → app handoff). */
    offerEndsAt?: string
}

/** Home CTAs that open the trial checkout; the app and backend recognise it by the experiment/variant pair. */
const DIRECT_SIGNUP_CTAS: ReadonlySet<AppOutboundCta> = new Set(['hero_cta', 'header_cta', 'pricing_cta'])

export function buildAppOutboundUrl(cta: AppOutboundCta, options?: AppOutboundOptions): string {
    const isDirectSignup = DIRECT_SIGNUP_CTAS.has(cta)
    const path = cta === 'client_access' ? '/login' : isDirectSignup ? '/signup/google' : '/signup'
    const params = new URLSearchParams({
        utm_source: 'oidotipi.com',
        utm_medium: 'landing',
        utm_campaign: FOOD_COST_LANDING_PAGE,
        utm_content: cta,
        landing_page: FOOD_COST_LANDING_PAGE,
    })
    const leadId = options?.leadId?.trim()
    if (leadId) {
        params.set('leadId', leadId)
    }
    const offerEndsAt = options?.offerEndsAt?.trim()
    if (offerEndsAt) {
        params.set('offerEndsAt', offerEndsAt)
    }
    if (isDirectSignup) {
        params.set('experiment', LANDING_DIRECT_CONVERSION_EXPERIMENT)
        params.set('variant', LANDING_DIRECT_CONVERSION_TREATMENT)
    }
    return `${resolveAppOrigin()}${path}?${params.toString()}`
}
